import md5 from '@/renderer/scripts/libs/md5';
const CACHEKEY = 'UPLOAD_ID_CACHE';
const EXPIRES = 30 * 24 * 3600;

interface FileIDParams {
  name: string; // 文件名
  remotePath: string; // 文件网盘全路径
  size: number;
  mtime: number;
  syncId?: number; // 同步任务时会存在该字段
}

// 按照文件特征值，缓存 ConfirmKey

// type ConfirmKeyList = Record<string, Array<string>>;

class ConfirmKeyCache {
  public cache: Array<Array<string | number>>;
  private timer = 0;
  public using: Record<string, boolean>;
  constructor() {
    this.using = {};
    this.cache = [];
    this.timer = 0;
    this.init();
  }

  /**
   * @description 设置 ConfirmKey 正在使用
   * @param {string} ConfirmKey
   * @memberof ConfirmKeyCache
   */
  setUsing(ConfirmKey: string): void {
    this.using[ConfirmKey] = true;
  }

  /**
   * @description 标记 ConfirmKey 已经没在使用
   * @param {string} ConfirmKey
   * @memberof ConfirmKeyCache
   */
  removeUsing(ConfirmKey: string): void {
    delete this.using[ConfirmKey];
  }

  /**
   * @description 获取文件对应的 ConfirmKey
   * @param {string} uuid
   * @return {*}  {string[]}
   * @memberof ConfirmKeyCache
   */
  getConfirmKeyList(uuid: string): string[] {
    const list: string[] = [];
    if (!uuid) return list;
    this.init();
    for (let i = 0; i < this.cache.length; i++) {
      if (this.cache[i][0] === uuid) list.push(this.cache[i][1] as string);
    }
    return list;
  }

  /**
   * @description 缓存 ConfirmKey
   * @param {string} uuid
   * @param {string} ConfirmKey
   * @param {number} limit 限制缓存多少个 ConfirmKey
   * @return {*}  {void}
   * @memberof ConfirmKeyCache
   */
  saveConfirmKey(uuid: string, ConfirmKey: string, limit = 50): void {
    this.init();
    if (!uuid) return;
    // 清理没用的 ConfirmKey，js 文件没有 FilePath ，只清理相同记录
    for (let i = this.cache.length - 1; i >= 0; i--) {
      const item = this.cache[i];
      if (item[0] === uuid && item[1] === ConfirmKey) {
        this.cache.splice(i, 1);
      }
    }
    this.cache.unshift([uuid, ConfirmKey, Math.round(Date.now() / 1000)]);
    if (this.cache.length > limit) this.cache.splice(limit);
    this.save();
  }

  /**
   * @description ConfirmKey 已用完，移除掉
   * @param {string} ConfirmKey
   * @memberof ConfirmKeyCache
   */
  removeConfirmKey(ConfirmKey: string) {
    this.init();
    delete this.using[ConfirmKey];
    for (let i = this.cache.length - 1; i >= 0; i--) {
      if (this.cache[i][1] === ConfirmKey) this.cache.splice(i, 1);
    }
    this.save();
  }

  /**
   * @description 用上传参数生成哈希值
   * @static
   * @param {*} file 上传的文件信息
   * @param {*} ChunkSize 分块大小
   * @param {string} confirmKey 上传文件名
   * @return {*}
   * @memberof ConfirmKeyCache
   */
  // eslint-disable-next-line class-methods-use-this
  getFileId(params: FileIDParams, ChunkSize: number) {
    const { name, size, mtime, remotePath, syncId } = params;
    if (name && size && mtime && ChunkSize && remotePath) {
      if (syncId) {
        return md5([name, size, mtime, ChunkSize, remotePath, syncId].join('::'));
      }
      return md5([name, size, mtime, ChunkSize, remotePath].join('::'));
    }
    return '';
  }
  private init() {
    if (this.cache.length > 0) return;
    this.getCache();
    // 清理太老旧的数据
    let changed = false;
    const now = Math.round(Date.now() / 1000);
    for (let i = this.cache.length - 1; i >= 0; i--) {
      const birthTime = this.cache[i][2];
      if (!birthTime || new Date(birthTime).getTime() + EXPIRES < now) {
        this.cache.splice(i, 1);
        changed = true;
      }
    }
    if (changed) {
      this.setCache();
    }
  }
  private getCache() {
    let val = [];
    try {
      val = JSON.parse(localStorage.getItem(CACHEKEY) as string);
    } catch (e) {
      val = [];
    }
    this.cache = val || [];
  }
  private setCache() {
    try {
      localStorage.setItem(CACHEKEY, JSON.stringify(this.cache));
    } catch (e) {
      localStorage.setItem(CACHEKEY, '');
    }
  }

  /**
   * @description 控制将缓存保存本地的频率
   * @private
   * @return {*}  {void}
   * @memberof ConfirmKeyCache
   */
  private save(): void {
    if (this.timer) return;
    this.timer = window.setTimeout(() => {
      this.setCache();
      this.timer = 0;
    }, 400);
  }
}
export default new ConfirmKeyCache();
